import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
const Root = styled.div.withConfig({
  displayName: "FormGroup__Root",
  componentId: "sc-19e7hy9-0"
})(["", " display:flex;flex-wrap:wrap;flex-direction:column;> label:not(:last-child){margin:0 0 var(--size-spacing-02) 0;}", ""], ScopedCssBaseline, ({
  row
}) => row && css(["flex-direction:row;> label:not(:last-child){margin:0 var(--size-spacing-04) 0 0;}"]));
const FormGroup = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref
  }, rest), children);
});
FormGroup.displayName = 'FormGroup';
FormGroup.propTypes = {
  /**
   * Sets the children
   */
  children: PropTypes.node.isRequired,

  /**
   * Sets the alignment in the row direction. By default is in the column direction
   */
  row: PropTypes.bool
};
export default FormGroup;